import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import GoogleSignInButton from "@/components/GoogleSignInButton";
import { toast } from "sonner";

export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      login(data.token, data.user);
      toast.success("Autentificare reușită");
      navigate(data.user.role === "admin" ? "/admin" : "/cont");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="border border-slate-200 p-8">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500">Cont</span>
        <h1 className="text-3xl font-black tracking-tight mt-2 mb-8">Autentificare</h1>
        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Email</label>
            <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-none border-slate-300 h-12 mt-2" data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wide font-bold text-slate-500">Parolă</label>
            <Input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-none border-slate-300 h-12 mt-2" data-testid="login-password" />
          </div>
          <button disabled={loading} className="w-full bg-orange-600 hover:bg-orange-700 disabled:opacity-60 text-white px-6 py-4 font-bold uppercase tracking-wide text-sm transition-colors" data-testid="login-submit">
            {loading ? "Se procesează..." : "Autentificare"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-5">
          <span className="h-px bg-slate-200 flex-1" />
          <span className="text-[11px] uppercase tracking-wide text-slate-400 font-bold">sau</span>
          <span className="h-px bg-slate-200 flex-1" />
        </div>
        <GoogleSignInButton label="Autentificare cu Google" />
        <p className="text-[11px] text-slate-400 mt-3 text-center leading-relaxed" data-testid="login-google-notice">{t("consent.google")}</p>
        <p className="text-sm text-center mt-4">
          <Link to="/recuperare-parola" className="text-slate-500 hover:text-orange-600 transition-colors" data-testid="forgot-password-link">{t("auth.forgotLink")}</Link>
        </p>
        <p className="text-sm text-slate-500 mt-4 text-center">
          Nu ai cont? <Link to="/inregistrare" className="text-orange-600 font-semibold hover:underline">Înregistrează-te</Link>
        </p>
      </div>
    </div>
  );
}
